<template>
  <div class="y-category-tree">
    <tree-menu
        :key="child.name"
        v-for="child in categories"
        :children="child.children"
        :name="child.name"
        :slug="child.full_slug"
        :depth="0"
    >
    </tree-menu>
  </div>
</template>
<script>
import axios from "axios";
import CategoryTree from './category-tree.vue';
import {mapState} from "vuex";

export default  {
  // el: '.y-category-tree',
  components: {
    'tree-menu' : CategoryTree
  },
  computed: {
    ...mapState(["scrollYCat"]),
  },
  methods: {
    scroll() {
      if(document.referrer.includes("/products/")) {
        window.scrollTo({top: this.scrollYCat, behavior: 'auto'});
      }
    },
  },
  data() {
    return {
      categories: {},
      currentCategoryId: jQuery("#data-cat").data("cat"),

    }
  },
  mounted() {
    let form_data = new FormData;
    form_data.append('action', 'yodah_category_tree_query');
    axios.post(my_ajax_object.ajax_url, form_data)
        .then(response => {
          this.categories = response.data.data;
        }).catch(error => {
      console.log('there was a problem...', error);
    });
    if(window.location.href.includes("/products/")) {
      this.$store.commit('updateCurrentSlug', window.location.pathname);
    }
    // console.log('current slug', window.location.pathname);
    setTimeout(this.scroll, 500);
  },

};

</script>